export const CHAPTER_API_ROUTES = {
  GET_CHAPTER: "admin/chapter",
  GET_CHAPTER_BY_ID: "admin/chapter/:id",
  CREATE_CHAPTER: "admin/chapter",
  UPDATE_CHAPTER: "admin/chapter/:id",
  DELETE_CHAPTER: "admin/chapter/:id",
};
